import { mutatePromotionEntry } from '../../infra/api/mutatePromotionEntry';
import { useBaseParam } from './useBaseParam';

const usePromoBloc = (condition?: any) => {
  const putPromotionEntry = useBaseParam(mutatePromotionEntry, condition);

  return { putPromotionEntry };
};

export default usePromoBloc;
